import React from "react";

// Reuse the same W/D/L palette as YourPoints.js's ptColor() thresholds.
export const RESULT_COLORS = { W: "#22c55e", D: "#9ca3af", L: "#ef4444" };
const RESULT_LABELS = { W: "Win", D: "Draw", L: "Loss" };

// Result is only computed once BOTH scores are present and numeric.
export function computeMatchResult(yourScore, theirScore) {
  if (yourScore === "" || yourScore === null || yourScore === undefined) return null;
  if (theirScore === "" || theirScore === null || theirScore === undefined) return null;
  const y = Number(yourScore);
  const t = Number(theirScore);
  if (Number.isNaN(y) || Number.isNaN(t)) return null;
  if (y > t) return "W";
  if (y < t) return "L";
  return "D";
}

const labelStyle = {
  display: "block",
  fontSize: "0.85rem",
  fontWeight: "600",
  marginBottom: "4px",
  color: "#444",
};

const inputStyle = {
  width: "100%",
  padding: "8px 12px",
  borderRadius: "6px",
  border: "1px solid #e5e7eb",
  fontSize: "0.95rem",
  boxSizing: "border-box",
};

const MatchScoreStep = ({ matchScore = {}, setMatchScore }) => {
  const { opponent = "", yourScore = "", theirScore = "" } = matchScore || {};

  const result = computeMatchResult(yourScore, theirScore);

  const update = (field, value) => {
    setMatchScore((prev) => ({ ...(prev || {}), [field]: value }));
  };

  return (
    <div>
      <div
        style={{
          fontStyle: "italic",
          marginBottom: 8,
          fontSize: "0.9em",
        }}
      >
        Optional — record the final score for this match. Leave blank if you'd rather skip it.
      </div>

      <div style={{ marginBottom: 12 }}>
        <label style={labelStyle}>Opponent</label>
        <input
          type="text"
          placeholder="Opponent name"
          value={opponent}
          onChange={(e) => update("opponent", e.target.value)}
          style={inputStyle}
        />
      </div>

      <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
        <div style={{ flex: 1 }}>
          <label style={labelStyle}>Your Score</label>
          <input
            type="number"
            min="0"
            placeholder="0"
            value={yourScore}
            onChange={(e) => update("yourScore", e.target.value)}
            style={inputStyle}
          />
        </div>
        <div style={{ flex: 1 }}>
          <label style={labelStyle}>Their Score</label>
          <input
            type="number"
            min="0"
            placeholder="0"
            value={theirScore}
            onChange={(e) => update("theirScore", e.target.value)}
            style={inputStyle}
          />
        </div>
      </div>

      {result && (
        <div
          style={{
            display: "inline-block",
            padding: "4px 12px",
            borderRadius: "999px",
            background: `${RESULT_COLORS[result]}1A`,
            color: RESULT_COLORS[result],
            fontWeight: "700",
            fontSize: "0.85rem",
          }}
        >
          {RESULT_LABELS[result]} ({result})
        </div>
      )}
    </div>
  );
};

export default MatchScoreStep;
